import {
  INVITEE_AUTHORIZED,
  INVITEE_REGION_UPDATED,
  INVITEE_EVENTS_UPDATED,
  INVITEE_INVITATION_UPDATED,
  INVITEE_ATTENDEES_UPDATED,
  INVITEE_ID_UPDATED,
  INVITEE_NAMES_UPDATED,
  INVITEE_RESET,
  INVITEE_BA_UPDATED,
} from './actionTypes';
import { NotificationManager } from 'react-notifications';
const WEBSITE_URL = process.env.REACT_APP_API_URL;

export const resetInvitee = () => ({
  type: INVITEE_RESET,
});

export const updateRegion = region => ({
  type: INVITEE_REGION_UPDATED,
  region,
});

export const updateId = id => ({
  type: INVITEE_ID_UPDATED,
  id,
});

export const updateNumAttendees = id => ({
  type: INVITEE_ATTENDEES_UPDATED,
  id,
});

export const updateNames = names => ({
  type: INVITEE_NAMES_UPDATED,
  names,
});

export const updateBa = ba => ({
  type: INVITEE_BA_UPDATED,
  ba,
});

export const updateEvents = events => ({
  type: INVITEE_EVENTS_UPDATED,
  events,
});

export const updateInvitation = invitation => ({
  type: INVITEE_INVITATION_UPDATED,
  invitation_style: invitation,
});

export const setAuthorized = authorized => ({
  type: INVITEE_AUTHORIZED,
  authorized,
});

// Action Creators

export function inviteeUpdated(invitee) {
  return dispatch => {
    dispatch(updateRegion(invitee.region));
    dispatch(updateId(invitee.id));
    dispatch(updateNumAttendees(invitee.attendees));
    dispatch(updateNames(invitee.names));
    dispatch(updateEvents(invitee.events));
    dispatch(updateBa(invitee.ba));
  };
}

export function inviteeReset() {
  return dispatch => {
    dispatch(resetInvitee());
  };
}

export function inviteeRegionUpdated(region) {
  return dispatch => {
    dispatch(updateRegion(region));
  };
}

export function inviteeEventsUpdated(eventName, events) {
  const obj = Object.assign({}, events);

  if (obj[eventName] === undefined) {
    obj[eventName] = [];
  } else {
    delete obj[eventName];
    // obj[eventName] = undefined;
  }
  return dispatch => {
    dispatch(updateEvents(obj));
  };
}

export function inviteeRSVPChanged(eventName, fullName) {
  return (dispatch, getState) => {
    const state = getState();
    const events = Object.assign({}, state.invitee.events);
    const allNames = events[eventName] || [];
    const names = allNames.filter(x => x !== null);

    // If name not already rsvp'd
    const name = fullName.split(' ')[0];
    const index = names.indexOf(name);
    if (index === -1) {
      names.push(name);
    } else {
      names.splice(index, 1);
    }

    events[eventName] = names;

    dispatch(updateEvents(events));
    setServerRSVP(state.invitee.id, {
      [eventName]: names,
    });
  };
}

export async function visited(inviteeId) {
  const request = await fetch(`${WEBSITE_URL}/invitees/${inviteeId}/visited`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
  });

  await request.text(); // OK
}

async function setServerRSVP(inviteeId, event) {
  const request = await fetch(`${WEBSITE_URL}/invitees/${inviteeId}/rsvp`, {
    method: 'PUT',
    body: JSON.stringify(event),
    headers: {
      'content-type': 'application/json',
    },
  });

  await request.text(); // OK
  NotificationManager.success(`Saved!`, '', 2000);
}

export function inviteeInvitationUpdated(invitation) {
  return dispatch => {
    dispatch(updateInvitation(invitation));
  };
}

export function inviteeAuthorized(authorized = true) {
  return dispatch => {
    dispatch(setAuthorized(authorized));
  };
}



// WEBPACK FOOTER //
// ./src/actions/invitee.js